export default {
  /*按钮*/
  bt:{
    search:"Tìm kiếm",
    query:"Tra cứu",
    operation:"Thao tác",
    add:"Thêm",
    edit:"Sửa",
    delete:"Xóa",
    down:"Tải",
    export:"Dẫn ra",
    upload:"Tải lên"
  },
  accountDataTable:{
    updateTime: 'Thời gian cập nhật:',
    sumAccountReal:'Số lần thử lại',
    sumAccountDemo:'Số tài khoản mô phỏng mới',
    sumDayAccountReal: 'Số báo cáo trung bình hàng ngày',
    sumDayAccountDemo:'Số trung bình tài khoản mô phỏng mỗi ngày',
    day:"ngày",
    weekBy:'tuần',
    monthBy:'tháng',
    detail:'chi tiết',
    export:'xuất',
    date:'ngày',
    realCount:'Số lần thử lại',
    demoCount:'Số tài khoản mô phỏng',
    time:'Thời gian mở',
    advertisingChannel:'Nguồn kênh',
    advertisingSeries:'Nguồn hàng loạt',
    advertisingMj:'Nguồn phương tiện',
  },
  activateDataTable:{
    addActivate:'Số lần thử lại',
    dayActivate:'Số tài khoản được kích hoạt vào ngày hôm nay',
    avgActivate:'Số trung bình tài khoản kích hoạt mỗi ngày',
    avgDayActivate:'Số tài khoản hoạt động hàng ngày trong cùng ngày',
    ratio:'Tỷ lệ kích hoạt trong cùng ngày',
    activateCount:'Kích hoạt tài khoản',
    dayActivateCount:'Tài khoản kích hoạt cùng ngày',
    oldAccount:'Số tài khoản cũ được kích hoạt',
    newThan:'Tỷ lệ tài khoản được kích hoạt cùng ngày',
    oldThan:'Tỷ lệ kích hoạt tài khoản cũ',
    time:'Thời gian hoạt động',
  },
  depositTable:{
    depositAccount:'Số lần thử lại',
    depositCount:'Thời tiết tháng',
    againDepositionAccount:'Số tài khoản được bố trí',
    depositAmount:'Gửi tới USD',
    avgDeposit:'Số lần đổ đầu người',
    avgDepositAmount:'Gửi đầu tư người máy (USD)',
    amountAccount:'Số lần thử lại',
    amountCount:'Thời tiết tháng',
    afterDeposit:'Số tài khoản được bố trí',
    time:'Thời gian tháng',
    inChannel:'Tất cả bục',
    payWay:'Trả đầy đủ',
  },
  depositMoneyTable:{
    amountMoney:'Gửi ngân phiếu',
    amountAccountCount:'Số lần thử lại',
    amountCount:'Thời tiết tháng',
  },
  poorTable:{
    withdrawalAccount:'Số tài khoản rút lui',
    withdrawalAmount:'Số rút lui (USD)',
    poorAmount:'Khoảng cách',
    time:'Khoảng thời gian',
  },
  withdrawalTable:{
    withdrawalCount:'Giờ rút lui',
    avgWithdrawal:'Số rút tiền trên đầu người',
    avgWithdrawalAmount:'Số rút tiền đầu tư (USD)',
  },
  realTable:{
    realAccount:'Số lần thử lại',
    realCount:'Số lần thử lại',
    realHandCount:'Số lần thử lại',
    againRealHandCount:'Số lần thử lại',
    dayAvgAccount:'Số tài khoản thương mại hàng ngày',
    time:'Giờ trao đổi',
    productType:'Kiểu sản phẩm',
    product:'Mọi sản phẩm',
  },
  realProduction:{
    production:'Thương mại',
  },
  device: {
    startTime: 'TG bắt đầy thống kê',
    endTime: 'TG kết thúc thống kê',
    type: "Hành vi",
    activation: "Trạng thái",
    source: "Nguồn kênh",
    medium: "Môi giới quảng cáo",
    series: "Quảng cáo",
    account: "Tài khoản",
    enable: "Khởi dụng",
    landing: "Đăng Nhập",
    beenActivated: "Đã kích hoạt",
    notActivated: "Chưa kích hoạt",
    deviceVendor: "Tỷ lệ nhà máy thiết bị",
    model: "Tỷ lệ loại thiết bị",
    form: "Tỷ lệ hệ thống điều hành",
    version: "Tỷ lệ phiên bản hệ thống",
    updateTime: "TG cập nhật",
    vendor: "Nhà máy",
    userCount: "Số người dụng",
    userRatio: "Tỷ lệ người dùng",
    accessCount: "Số lần",
    accessRatio: "Tỷ lệ số lần",
    deviceModel: "Loại thiết bị",
    platform: "Hệ thống điều hành",
    osVersion: "Phiên bản hệ thống",
    other: "Khác",
    export: "Tải xuống",
    systemAnaly: "Thống kê phân phối hệ thống",
    phoneAnaly: "Thống kê phân phối điện thoại di động",
    phoneSystemAnaly: "Thống kê phân phối điện thoại di động",
    appVersionAnaly: "Thống kê phân phối phiên bản ứng dụng",
    phoneWifiAnaly: "Thống kê phân phối tín hiệu điện thoại di động",
    appChannelAnaly: "Thống kê phân phối kênh ứng dụng",
    md5: "Hồ sơ được liên kết",
    networkType: "Tín hiệu mạng thiết bị",
    packageName: "tên gói ứng dụng",
    appVerCode: "phiên bản ứng dụng",
    channel: "kênh",
    recordTime: "Thời gian đăng nhập",
    time: "time",
    ipAdd: "ipAdd",
    recordType: "recordType",
    operates: "操作",
    exportFile: "exportFile",
    faidStr:"設備號",
    androidId:"AndoirdId",
    businessType:"businessType",
    valueOne:"其它信息"
  },
  riskAnalyse: {
    platform: 'Nền tảng giao dịch',
    accountNo: 'Tài khoản giao dịch',
    customerNumber: 'Tài khoản thống nhất',
    activateTime: 'Thời gian kích hoạt',
    referrerNumber: 'Người giới thiệu',
    firstTimeCashInCurrency: 'Tiền tệ nạp lần đầu',
    totalCashIn: 'Tổng nạp',
    totalCashOut: 'Tổng rút',
    netCashIn: 'Tổng nạp ròng',
    bonusSent: 'Tiền thưởng đã gửi',
    bonusDeducted: 'Tiền thưởng đã khấu trừ',
    rewardSent: 'Phần thưởng đã gửi',
    rewardDeducted: 'Phần thưởng đã thu hồi',
    earnedBonus: 'Tổng tiền thưởng nhận được',
    totalTrade: 'Tổng số lần giao dịch',
    totalVolume: 'Tổng khối lượng giao dịch',
    totalProfit: 'Tổng lợi nhuận',
    highProfitMultiple: 'Bội số lợi nhuận (lần)',
    totalClearZero: 'Tổng số lần xóa không',
    shortTermTradeRatioPct: 'Tỷ lệ giao dịch ngắn hạn (%)',
    shortTermProfitRatioPct: 'Tỷ lệ lợi nhuận ngắn hạn (%)',
    top3ProfitableSymbols: 'Top 3 sản phẩm lợi nhuận',
    openIp: 'IP mở tài khoản',
    ipUsageCount: 'Số lượng dùng chung IP',
    sharedCustomerNumbers: 'Tài khoản dùng chung IP',
    ipRegLocationCn: 'Khu vực IP',
    idRegLocationCn: 'Khu vực CMND',
    mobilePhoneRegLocationCn: 'Khu vực số điện thoại',
    latestBalance: 'Số dư mới nhất',
    latestEquity: 'Vốn chủ sở hữu mới nhất',
    latestSettleDate: 'Ngày quyết toán mới nhất',
    queryDays: 'Số ngày thống kê',
    thirtyDays: '30 ngày',
    sixtyDays: '60 ngày',
    isSharedIp: 'Lọc IP dùng chung',
    yes: 'Có',
    no: 'Không',
    shortTermTradeRatioThreshold: 'Ngưỡng tỷ lệ giao dịch ngắn hạn',
    shortTermProfitRatioThreshold: 'Ngưỡng tỷ lệ lợi nhuận ngắn hạn',
    ipPlaceholder: 'Vui lòng nhập địa chỉ IPv4 hợp lệ',
    thresholdPlaceholder: 'Hỗ trợ 2 chữ số thập phân (VD: 0.15)',
    ipError: 'Định dạng IP mở tài khoản không hợp lệ, vui lòng nhập IPv4 hợp lệ',
    tradeRatioError: 'Ngưỡng tỷ lệ giao dịch ngắn hạn không hợp lệ, phải là số và tối đa 2 chữ số thập phân',
    profitRatioError: 'Ngưỡng tỷ lệ lợi nhuận ngắn hạn không hợp lệ, phải là số và tối đa 2 chữ số thập phân',
    customerAccount: 'Tài khoản khách hàng',
    customerAccountPlaceholder: 'Vui lòng nhập tài khoản khách hàng',
    customerAccountError: 'Định dạng tài khoản khách hàng không hợp lệ, vui lòng nhập số nguyên hợp lệ',
    noRecord: 'Không có bản ghi liên quan',
    customerAccountEmpty: 'Vui lòng nhập tài khoản khách hàng',
    export: 'Xuất khẩu',
    exportMessage: 'Nếu có nhiều dữ liệu truy vấn, thời gian chờ có thể hơn 10 giây.',
    exporting: 'Đang xuất, vui lòng đợi...',
    exportFailed: 'Xuất thất bại',
    exportNetworkError: 'Xuất thất bại, vui lòng kiểm tra kết nối mạng',
    customerAccountPlaceholder: 'Nhập tài khoản, phân tách bằng dấu phẩy',
    customerAccountLimit: 'Bạn có thể tra cứu tối đa 200 tài khoản mỗi lần',
    empty: '-',
    totalCommission: 'Tổng hoa hồng',
    totalSwap: 'Tổng tiền lãi',
    source: 'Nguồn quảng cáo',
    medium: 'Phương tiện',
    customTime: 'Thời gian tùy chỉnh giao dịch',
    threeHundredSixtyFiveDays: '365 ngày',
    shortTermSeconds: 'Số giây giao dịch ngắn hạn',
    uriTooLong: 'Tham số truy vấn quá dài, vui lòng giảm số lượng tài khoản mỗi lần tra cứu',
  }
}
